let dickiesFitHubModalLastOpener = null;

const fitHubSafeKey = (key) => String(key).replace(/[^a-z0-9_-]/gi, '-');

const restoreAfterFitHubModalClose = () => {
  document.body.classList.remove('fit-hub-modal-open');
  dickiesFitHubModalLastOpener?.focus();
  dickiesFitHubModalLastOpener = null;
};

function initDickiesPageHoverMediaCardRoot(root) {
  if (!root || root.getAttribute('data-dickies-hover-js') === 'true') return;
  root.setAttribute('data-dickies-hover-js', 'true');

  const resetVideo = (videoEl) => {
    if (!videoEl) return;
    videoEl.pause();
    videoEl.currentTime = 0;
  };

  const pauseHiddenPanelVideos = () => {
    root.querySelectorAll('.js-dickies-hover-tab-panel:not(.active) video.onlydesk').forEach(resetVideo);
  };

  const tryPlayHoverVideo = (videoEl) => {
    const dataSrc = videoEl.getAttribute('data-src');
    if (dataSrc && !videoEl.getAttribute('src')) {
      videoEl.setAttribute('src', dataSrc);
      videoEl.load();
    }
    videoEl.play().catch(() => {
      videoEl.addEventListener(
        'loadeddata',
        () => {
          videoEl.play().catch(() => {});
        },
        { once: true }
      );
    });
  };

  const playActiveMobileCardVideos = () => {
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    root.querySelectorAll('.fit-hub-card-media.js-image.fit-hub-card__media').forEach((imageRoot) => {
      const mobileVideo = imageRoot.querySelector('.fit-hub-card-media__hover.onlymob');
      const deskVideo = imageRoot.querySelector('.fit-hub-card-media__hover.onlydesk');
      const activeVideo = mobileVideo || deskVideo;

      if (mobileVideo) imageRoot.classList.add('fit-hub-card-media--has-mob-video');
      else imageRoot.classList.remove('fit-hub-card-media--has-mob-video');

      if (!activeVideo) return;

      const panel = activeVideo.closest('.js-dickies-hover-tab-panel');
      const isHiddenPanel = panel && !panel.classList.contains('active');
      if (!isMobile || isHiddenPanel) {
        resetVideo(mobileVideo);
        resetVideo(deskVideo);
        return;
      }

      activeVideo.muted = true;
      activeVideo.playsInline = true;
      activeVideo.autoplay = true;
      tryPlayHoverVideo(activeVideo);

      if (activeVideo !== mobileVideo) resetVideo(mobileVideo);
      if (activeVideo !== deskVideo) resetVideo(deskVideo);
    });
  };

  root.querySelectorAll('.fit-hub-card-media.js-image.fit-hub-card__media').forEach((imageRoot) => {
    if (imageRoot.dataset.dickiesDeskHoverInit === 'true') return;
    const deskVideo = imageRoot.querySelector('.js-image__video.onlydesk');
    if (!deskVideo) return;
    imageRoot.dataset.dickiesDeskHoverInit = 'true';
    imageRoot.addEventListener('mouseenter', () => {
      imageRoot.classList.add('dickies-hover-media--over');
      tryPlayHoverVideo(deskVideo);
    });
    imageRoot.addEventListener('mouseleave', () => {
      imageRoot.classList.remove('dickies-hover-media--over');
      resetVideo(deskVideo);
    });
  });
  playActiveMobileCardVideos();

  const tabRoot = root.querySelector('.js-dickies-hover-tabs');
  if (tabRoot) {
    tabRoot.querySelectorAll('.js-dickies-hover-tab-trigger').forEach((btn) => {
      btn.addEventListener('click', () => {
        const group = btn.getAttribute('data-tab-group');
        if (!group) return;
        tabRoot.querySelectorAll('.js-dickies-hover-tab-trigger').forEach((b) => {
          b.classList.toggle('active', b === btn);
        });
        root.querySelectorAll('.js-dickies-hover-tab-panel').forEach((panel) => {
          panel.classList.toggle('active', panel.getAttribute('data-tab-group') === group);
        });
        pauseHiddenPanelVideos();
        playActiveMobileCardVideos();
      });
    });
  }

  const modalContent = root.querySelector('[data-fit-hub-modal-content]');
  const modalRoot = root.querySelector('[data-fit-hub-modal-root]');
  if (modalContent && modalRoot) {
    const openModal = (modalKey) => {
      modalRoot.hidden = false;
      document.body.classList.add('fit-hub-modal-open');
      const dialog = modalRoot.querySelector('[role="dialog"]');
      const title = modalContent.querySelector('.fit-hub-modal__title');
      if (dialog && title) {
        title.id = `fh-modal-title-${fitHubSafeKey(modalKey)}`;
        dialog.setAttribute('aria-labelledby', title.id);
      } else {
        dialog?.removeAttribute('aria-labelledby');
      }
      requestAnimationFrame(() => {
        const tab = modalContent.querySelector('[role="tab"]');
        if (tab) {
          tab.focus();
          return;
        }
        modalRoot.querySelector('[data-fit-hub-modal-close]')?.focus();
      });
    };
    const closeModal = () => {
      modalRoot.hidden = true;
      modalRoot.querySelector('[role="dialog"]')?.removeAttribute('aria-labelledby');
      restoreAfterFitHubModalClose();
    };
    const playActiveModalVideo = () => {
      const panels = modalContent.querySelectorAll('[data-fit-hub-modal-tab-panel]');
      let activeContainer = modalContent;
      if (panels.length > 0) {
        activeContainer =
          modalContent.querySelector('[data-fit-hub-modal-tab-panel].active') || panels[0];
        panels.forEach((panel) => {
          if (panel === activeContainer) return;
          resetVideo(panel.querySelector('video.video-media__video-element'));
        });
      }
      const activeVideo = activeContainer.querySelector('video.video-media__video-element');
      if (!activeVideo) return;
      activeVideo.play().catch(() => {});
    };
    const initFitHubModalTabs = (modalKey) => {
      const tabRoot = modalContent.querySelector('[data-fit-hub-modal-tabs]');
      const triggers = modalContent.querySelectorAll('[data-fit-hub-modal-tab-trigger]');
      const panels = modalContent.querySelectorAll('[data-fit-hub-modal-tab-panel]');

      const setActiveTab = (tabId) => {
        triggers.forEach((button) => {
          const id = button.getAttribute('data-fit-hub-modal-tab-trigger');
          const active = id === tabId;
          button.classList.toggle('active', active);
          if (button.getAttribute('role') === 'tab') {
            button.setAttribute('aria-selected', active ? 'true' : 'false');
          }
        });
        panels.forEach((panel) => {
          const isActive = panel.getAttribute('data-fit-hub-modal-tab-panel') === tabId;
          panel.classList.toggle('active', isActive);
          panel.hidden = !isActive;
        });
        playActiveModalVideo();
      };

      if (!tabRoot) {
        playActiveModalVideo();
        return;
      }

      const safe = fitHubSafeKey(modalKey);
      if (triggers.length > 1) {
        tabRoot.setAttribute('role', 'tablist');
        triggers.forEach((trigger) => {
          const tabId = trigger.getAttribute('data-fit-hub-modal-tab-trigger');
          if (!tabId) return;
          trigger.setAttribute('role', 'tab');
          const baseId = `fh-tab-${safe}-${tabId}`;
          trigger.id = baseId;
          const panel = modalContent.querySelector(
            `[data-fit-hub-modal-tab-panel="${CSS.escape(tabId)}"]`
          );
          if (panel) {
            const panelId = `${baseId}-panel`;
            panel.setAttribute('role', 'tabpanel');
            panel.id = panelId;
            trigger.setAttribute('aria-controls', panelId);
            panel.setAttribute('aria-labelledby', baseId);
          }
        });
      }

      const firstTrigger = triggers[0];
      if (firstTrigger) {
        const firstTabId = firstTrigger.getAttribute('data-fit-hub-modal-tab-trigger');
        if (firstTabId) setActiveTab(firstTabId);
      }

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const tabId = trigger.getAttribute('data-fit-hub-modal-tab-trigger');
          if (!tabId) return;
          setActiveTab(tabId);
        });
      });
    };

    root.querySelectorAll('.js-fit-hub-card__cta').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const card = button.closest('.js-fit-hub-card');
        if (!card) return;
        const modalKey = card.getAttribute('data-modal');
        if (!modalKey) return;
        const template = Array.from(root.querySelectorAll('[data-fit-hub-popup-template]')).find(
          (node) => node.getAttribute('data-fit-hub-popup-template') === modalKey
        );
        if (!template) return;
        dickiesFitHubModalLastOpener = button;
        modalContent.innerHTML = template.innerHTML;
        initFitHubModalTabs(modalKey);
        openModal(modalKey);
      });
    });

    modalRoot.querySelectorAll('[data-fit-hub-modal-close]').forEach((button) => {
      button.addEventListener('click', closeModal);
    });
    const overlay = modalRoot.querySelector('[data-fit-hub-modal-overlay]');
    if (overlay) {
      overlay.addEventListener('click', (event) => {
        if (event.target === overlay) closeModal();
      });
    }
  }
}

function initAllDickiesPageHoverMediaCardRoots() {
  document.querySelectorAll('[data-dickies-page-hover-root]').forEach(initDickiesPageHoverMediaCardRoot);
}

document.addEventListener('DOMContentLoaded', initAllDickiesPageHoverMediaCardRoots);

if (!window.__dickiesPageHoverMediaCardSectionLoadBound) {
  window.__dickiesPageHoverMediaCardSectionLoadBound = true;
  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target;
    if (!(container instanceof Element)) return;
    const root = container.querySelector('[data-dickies-page-hover-root]');
    if (root) initDickiesPageHoverMediaCardRoot(root);
  });
}

if (!window.__dickiesFitHubModalEscapeBound) {
  window.__dickiesFitHubModalEscapeBound = true;
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    let closed = false;
    document.querySelectorAll('[data-fit-hub-modal-root]').forEach((modalEl) => {
      if (modalEl.hidden) return;
      modalEl.hidden = true;
      modalEl.querySelector('[role="dialog"]')?.removeAttribute('aria-labelledby');
      closed = true;
    });
    if (closed) restoreAfterFitHubModalClose();
  });
}
